import Cookies from "js-cookie"

const EURO_COUNTRIES = [
  "AT", // Austria
  "BE", // Belgium
  "CY", // Cyprus
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "IE", // Ireland
  "IT", // Italy
  "LV", // Latvia
  "LT", // Lithuania
  "LU", // Luxembourg
  "MT", // Malta
  "NL", // Netherlands
  "PT", // Portugal
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "HR", // Croatia
]

const GBP_COUNTRIES = [
  "GB", // United Kingdom
  "BG", // Bulgaria
  "CZ", // Czech Republic
  "DK", // Denmark
  "HU", // Hungary
  "PL", // Poland
  "RO", // Romania
  "SE", // Sweden
  "AL", // Albania
  "AD", // Andorra
  "AM", // Armenia
  "AZ", // Azerbaijan
  "BY", // Belarus
  "BA", // Bosnia and Herzegovina
  "IS", // Iceland
  "KV", // Kosovo
  "LI", // Liechtenstein
  "MD", // Moldova
  "MC", // Monaco
  "ME", // Montenegro
  "NO", // Norway
  "RU", // Russia
  "SM", // San Marino
  "RS", // Serbia
  "CH", // Switzerland
  "UA", // Ukraine
  "VA", // Vatican City
  "MK", // North Macedonia
  "TR", // Turkey
  "IM", // Isle of Man
  "GG", // Guernsey
  "JE", // Jersey
]

const LATAM_COUNTRIES = [
  "MX", // Mexico
  "GT", // Guatemala
  "HN", // Honduras
  "SV", // El Salvador
  "NI", // Nicaragua
  "CR", // Costa Rica
  "PA", // Panama
  "CO", // Colombia
  "EC", // Ecuador
  "PE", // Peru
  "BO", // Bolivia
  "BR", // Brazil
  "PY", // Paraguay
  "CL", // Chile
  "AR", // Argentina
  "UY", // Uruguay
  "CU", // Cuba
  "HT", // Haiti
  "DO", // Dominican Republic
  "PR", // Puerto Rico
]

// IE 11 does not support startsWith so this adds that functionality
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0
    return this.indexOf(searchString, position) === position
  }
}

/* Example cookieyes-consent cookie value
"consentid:VDRGODE3UW91SHFGOVpjaDFrbE1relM1eXRNbUNJVng,consent:yes,action:yes,necessary:yes,functional:no,analytics:yes,performance:no,advertisement:yes,other:no"
*/

// Read the cookieyes-consent cookie and return the value for the type passed
const readCookieyesCookie = type => {
  const cookieYesCookie = Cookies.get("cookieyes-consent")

  if (!cookieYesCookie) return ""

  const cookieValues = cookieYesCookie.split(",")

  const cookieValue = cookieValues.find(cookie => cookie.startsWith(type))

  return cookieValue ? cookieValue.split(":")[1] : ""
}

export const setReferrerCookie = () => {
  if (Cookies.get("exp_referrer")) {
    return
  }

  // If user has explicitly opted out of analytics, don't track referrer
  if (readCookieyesCookie("analytics") === "no") {
    return
  }

  const href = window.location.href

  const results = new RegExp("[\\?|&](referrer|gspk)=([^&#]*)").exec(href)
  let source = (results && results[1]) || ""
  let referrer = (results && results[2]) || ""

  if (referrer.length === 0) {
    referrer = "direct"
  }

  if (source.toLowerCase() === "gspk") {
    referrer = atob(referrer)
  }

  Cookies.set("exp_referrer", referrer, { expires: 30, path: "/" })
}

export const setSourceCookie = () => {
  if (Cookies.get("exp_source")) {
    return
  }

  // If user has explicitly opted out of analytics, don't track source
  if (readCookieyesCookie("analytics") === "no") {
    return
  }

  const href = window.location.href

  const sourceMatches = new RegExp("[\\?&]source=([^&#]*)").exec(href)

  const utmMedium = new RegExp("[\\?&]utm_medium=([^&#]*)").exec(href)
  const utmSource = new RegExp("[\\?&]utm_source=([^&#]*)").exec(href)
  const utmCampaign = new RegExp("[\\?&]utm_campaign=([^&#]*)").exec(href)

  let source = "direct"

  if (sourceMatches && sourceMatches[1]) {
    source = sourceMatches[1]
  } else if (
    utmMedium &&
    utmMedium[1] &&
    utmMedium[1] === "ppc" &&
    utmSource &&
    utmSource[1] &&
    utmCampaign &&
    utmCampaign[1]
  ) {
    source = utmMedium[1] + "-" + utmSource[1] + "-" + utmCampaign[1]
  } else if (utmSource && utmSource[1]) {
    source = utmSource[1]
  } else if (document.referrer !== "") {
    source = document.referrer.split("/")[2]
  }

  Cookies.set("exp_source", source, { expires: 30, path: "/" })
}

export const setOfferCookie = code => {
  Cookies.set("exp_offer", code, { expires: 30, path: "/" })
}

export const setGclidCookie = () => {
  if (Cookies.get("exp_gclid")) {
    return
  }

  const gclidCode = new URLSearchParams(window.location.search).get("gclid")

  if (gclidCode) {
    Cookies.set("exp_gclid", gclidCode, { expires: 30, path: "/" })
  }
}

export const getCookieForRegion = () => {
  return Cookies.get("exp_region")
}

export const setRegionCookie = region => {
  const cookieExpires = new Date()
  cookieExpires.setDate(cookieExpires.getDate() + 360)

  Cookies.set("exp_region", region, {
    expires: cookieExpires,
    path: "/",
  })
}

export const getRegionForCountry = country => {
  const existingRegionFromCookies = Cookies.get("exp_region")
  if (existingRegionFromCookies) return existingRegionFromCookies

  if (!country) return "US" // Default if no country is provided

  if (GBP_COUNTRIES.includes(country)) return "GB"
  if (EURO_COUNTRIES.includes(country)) return "EU"
  if (LATAM_COUNTRIES.includes(country)) return "LA"

  return "US" // Default if no region matches
}
